import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://pose.quest/api';

export default function QuickTools({ onGarantiPing, onProxyRefresh, pingResult, proxyStatus }) {
  const [gostStatus, setGostStatus] = useState({ gost_count: 0, pool_running: false, status: 'stopped' });
  const [gostLoading, setGostLoading] = useState(null);

  useEffect(() => {
    loadGostStatus();
    const interval = setInterval(loadGostStatus, 10000);
    return () => clearInterval(interval);
  }, []);

  const loadGostStatus = async () => {
    try {
      const r = await axios.get(`${API_URL}/pool/gost/status`);
      if (r.data.success) setGostStatus(r.data);
    } catch (e) {}
  };

  const handleGostAction = async (action) => {
    setGostLoading(action);
    try {
      await axios.post(`${API_URL}/pool/gost/control`, { action });
      setTimeout(loadGostStatus, 6000);
    } catch (e) {}
    setTimeout(() => setGostLoading(null), 6000);
  };

  return (
    <div className="bg-gray-900 border border-blue-500/30 rounded-xl p-4">
      <h3 className="text-blue-400 font-bold text-base mb-3">QUICK TOOLS</h3>
      <div className="grid grid-cols-2 gap-3 mb-3">
        <button onClick={onGarantiPing} className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-3 rounded-lg font-medium flex items-center justify-center gap-2 transition-all">
          Garanti Ping
          {pingResult && (
            <span className={`px-2 py-0.5 rounded text-xs ${pingResult.status === 'OK' ? 'bg-green-500' : 'bg-red-500'}`}>
              {pingResult.http_code}
            </span>
          )}
        </button>
        <button onClick={onProxyRefresh} className="bg-purple-600 hover:bg-purple-700 text-white px-4 py-3 rounded-lg font-medium flex items-center justify-center gap-2 transition-all">
          Proxy Refresh
          {proxyStatus && (
            <span className={`px-2 py-0.5 rounded text-xs ${proxyStatus.success ? 'bg-green-500' : 'bg-red-500'}`}>
              {proxyStatus.proxy_count || 'ERR'}
            </span>
          )}
        </button>
      </div>

      {/* Gost Proxy Control */}
      <div className="bg-black/30 rounded-xl p-3">
        <div className="flex items-center justify-between mb-2">
          <div className="flex items-center gap-2">
            <div className={`w-2.5 h-2.5 rounded-full ${gostStatus.gost_count > 0 ? 'bg-green-400 animate-pulse' : 'bg-red-500'}`}></div>
            <span className="text-gray-300 text-sm font-medium">Gost Proxy</span>
            <span className="text-gray-500 text-xs">{gostStatus.gost_count} ports</span>
          </div>
          <span className={`text-xs font-bold px-2 py-0.5 rounded ${gostStatus.gost_count > 0 ? 'bg-green-600/30 text-green-400' : 'bg-red-600/30 text-red-400'}`}>
            {gostStatus.gost_count > 0 ? 'RUNNING' : 'STOPPED'}
          </span>
        </div>
        <div className="grid grid-cols-2 gap-2">
          <button onClick={() => handleGostAction('start')} disabled={gostLoading === 'start'}
            className="bg-green-600/20 hover:bg-green-600/40 text-green-400 px-3 py-2 rounded-lg text-sm font-bold transition disabled:opacity-50">
            {gostLoading === 'start' ? '...' : '▶ START ALL'}
          </button>
          <button onClick={() => handleGostAction('stop')} disabled={gostLoading === 'stop'}
            className="bg-red-600/20 hover:bg-red-600/40 text-red-400 px-3 py-2 rounded-lg text-sm font-bold transition disabled:opacity-50">
            {gostLoading === 'stop' ? '...' : '■ STOP ALL'}
          </button>
        </div>
      </div>
    </div>
  );
}
